import React, { useState } from "react";
import NikeLogo from "../assets/favicon.ico";
import lock from "../assets/lock.png";
import arrowDown from "../assets/down-arrow.png";
import arrowUp from "../assets/up-arrow.png";
import { getTotalAmount, indiaCurrency, tax } from "../constants/services";
import { useDispatch, useSelector } from "react-redux";
import { selectCartItems, updateCartAsync } from "../features/cart/cartSlice";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import userSlice, {
  selectUserInfo,
  updateUserAsync,
} from "../features/user/userSlice";
import {
  createOrderAsync,
  selectCurrentOrder,
} from "../features/order/orderSlice";
import Swal from "sweetalert2";
const Checkout = ({ setPageSelectedAddress, setPagePaymentMethod }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector(selectCartItems);
  const [showSummery, setShowSummery] = useState(false);
  const user = useSelector(selectUserInfo);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const totalAmountExcludedTax = getTotalAmount(cartItems);
  const currentOrder = useSelector(selectCurrentOrder);
  const totalAmount = totalAmountExcludedTax + tax;
  const handleQuantity = (e, item) => {
    dispatch(updateCartAsync({ id: item.id, quantity: +e.target.value }));
  };
  const handlePayment = (e) => {
    setPaymentMethod(e.target.value);
  };
  const handleAddress = (e) => {
    setSelectedAddress(user.addresses[e.target.value]);
  };
  const handleOrder = function () {
    if (paymentMethod && selectedAddress) {
      dispatch(
        createOrderAsync({
          items: cartItems,
          user: user.id,
          totalAmount: totalAmount,
          totalItems: cartItems.length,
          paymentMethod,
          selectedAddress,
          status: "pending",
        })
      );
    } else {
      alert("Choose a addresss");
    }
  };
  setPageSelectedAddress(selectedAddress);
  setPagePaymentMethod(paymentMethod);
  const exitHandler = () => {
    Swal.fire({
      title: "Are you sure you want to end this checkout session?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, end it!",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/home");
      }
    });
  };
  return (
    <>
      {currentOrder && currentOrder.paymentMethod === "cash" && (
        <Navigate to={`/orderSuccess/${currentOrder.id}`}> </Navigate>
      )}
      {currentOrder && currentOrder.paymentMethod === "card" && (
        <Navigate to={`/checkoutCardPayment`}> </Navigate>
      )}
      <div className="mx-5 md:mx-12">
        <div className="navbar flex justify-between items-center ">
          <img src={NikeLogo} alt="" />

          <img src={lock} className="w-5 h-5" alt="" onClick={exitHandler} />
        </div>
        <div className="md:flex justify-evenly flex-row-reverse">
          <div className="summery my-12   ">
            <div
              className="first flex justify-between items-center"
              onClick={() => setShowSummery(!showSummery)}
            >
              <h2 className="text-lg ">Summery</h2>
              <div className="flex items-center space-x-5">
                <h4 className="text-lg font-semibold">
                  {indiaCurrency}
                  {totalAmount}({cartItems.length} items)
                </h4>
                <img
                  src={showSummery ? arrowUp : arrowDown}
                  className="w-4 h-4 md:hidden"
                  alt=""
                />
              </div>
            </div>
            <div
              className={`second ${showSummery ? "block" : "hidden"} md:block`}
            >
              {cartItems.length &&
                cartItems.map((item) => (
                  <div className="flex py-4 ">
                    <div className="item-img w-1/6 flex  justify-center mx-3">
                      <img
                        src={item.product.images[0]}
                        alt=""
                        className="w-16 h-16 md:w-36 md:h-36"
                      />{" "}
                    </div>
                    <div className="item-detail space-y-2 w-3/6 md:ml-5">
                      <p className=" text-base font-medium leading-6 text-gray-900">
                        {item.product.title}
                      </p>

                      <p>{item.product.category}</p>
                      <div className="flex">
                        <p className=" text-sm font-medium leading-6 text-gray-900">
                          Size :{" "}
                        </p>
                        <p>{item.size}</p>
                      </div>
                      <div className="flex">
                        <p className=" text-sm font-medium leading-6 text-gray-900">
                          Color :{" "}
                        </p>
                        <p>{item.color}</p>
                      </div>

                      <div className="text-gray-500">
                        <label
                          htmlFor="quantity"
                          className="inline mr-5 text-sm font-medium leading-6 text-gray-900 "
                        >
                          Qty
                        </label>
                        <select
                          value={item.quantity}
                          onChange={(e) => handleQuantity(e, item)}
                        >
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                    <div className="item-price flex w-2/6  md:justify-end">
                      <p className=" text-sm font-medium leading-6 text-gray-900">
                        MRP : {item.product.discountPrice}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
            <button
              onClick={handleOrder}
              className="w-full mx-9  bg-black text-white py-4 rounded-3xl my-8 mt-4 md:flex hidden justify-center items-center cursor-pointer hover:opacity-75 "
            >
              Checkout
            </button>
          </div>
          <div className="addresses"></div>
          <div className="form">
            <form
              className="bg-white px-5 py-12 mt-12 md:mt-0"
              noValidate
              onSubmit={handleSubmit((data) => {
                dispatch(
                  updateUserAsync({
                    ...user,
                    addresses: [...user.addresses, data],
                  })
                );
                reset();
              })}
            >
              <div className="space-y-12 ">
                <div className="border-b border-gray-900/10 pb-12">
                  <h2 className="text-2xl font-semibold leading-7 text-gray-900">
                    Personal Information
                  </h2>
                  <p className="mt-1 text-sm leading-6 text-gray-600">
                    Use a permanent address where you can receive mail.
                  </p>

                  <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div className="sm:col-span-4">
                      <label
                        htmlFor="full-name"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Full Name
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="full-name"
                          id="full-name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          autoComplete="given-name"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-4">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Email address
                      </label>
                      <div className="mt-2">
                        <input
                          id="email"
                          name="email"
                          type="email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi,
                              message: "Email is not valid",
                            },
                          })}
                          autoComplete="email"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-4">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Phone number
                      </label>
                      <div className="mt-2">
                        <input
                          id="phoneNumber"
                          name="phoneNumber"
                          type="tel"
                          {...register("phoneNumber", {
                            required: "Phone number is required",
                          })}
                          autoComplete="email"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="col-span-full">
                      <label
                        htmlFor="street-address"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Street address
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="street-address"
                          id="street-address"
                          {...register("street", {
                            required: "Street is required",
                          })}
                          autoComplete="street-address"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-2 sm:col-start-1">
                      <label
                        htmlFor="city"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        City
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="city"
                          id="city"
                          {...register("city", {
                            required: "City is required",
                          })}
                          autoComplete="address-level2"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-2">
                      <label
                        htmlFor="region"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        State / Province
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="region"
                          id="region"
                          {...register("state", {
                            required: "State is required",
                          })}
                          autoComplete="address-level1"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-2">
                      <label
                        htmlFor="postal-code"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        ZIP / Postal code
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="postal-code"
                          id="postal-code"
                          {...register("pinCode", {
                            required: "pinCode is required",
                          })}
                          autoComplete="postal-code"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex items-center justify-end gap-x-6">
                  <button
                    type="button"
                    className="text-sm font-semibold leading-6 text-gray-900"
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2  "
                  >
                    Add Address
                  </button>
                </div>

                <div className="border-b border-gray-900/10 pb-12">
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    Addresses
                  </h2>
                  <p className="mt-1 text-sm leading-6 text-gray-600">
                    Choose from Existing addresses
                  </p>
                  <ul role="list">
                    {user &&
                      user.addresses.map((address, index) => (
                        <li
                          key={index}
                          className="flex justify-between gap-x-6 px-5 py-5 border-solid border-2 border-gray-200"
                        >
                          <div className="flex gap-x-4">
                            <input
                              value={index}
                              onClick={(e) => handleAddress(e)}
                              name="address"
                              type="radio"
                              className="h-4 w-4 border-gray-800 text-gray-600 focus:ring-gray-600 cursor-pointer"
                            />
                            <div className="min-w-0 flex-auto">
                              <p className="text-sm font-semibold leading-6 text-gray-900">
                                {address.name}
                              </p>
                              <p className="mt-1 truncate text-xs leading-5 text-gray-500">
                                {address.street}
                              </p>
                              <p className="mt-1 truncate text-xs leading-5 text-gray-500">
                                {address.pinCode}
                              </p>
                            </div>
                          </div>
                          <div className="hidden sm:flex sm:flex-col sm:items-end">
                            <p className="text-sm leading-6 text-gray-900">
                              Phone: {address.phoneNumber}
                            </p>
                            <p className="text-sm leading-6 text-gray-500">
                              {address.city}
                            </p>
                          </div>
                        </li>
                      ))}
                  </ul>

                  <div className="mt-10 space-y-10">
                    <fieldset>
                      <legend className="text-sm font-semibold leading-6 text-gray-900">
                        Payment Methods
                      </legend>
                      <p className="mt-1 text-sm leading-6 text-gray-600">
                        Choose One
                      </p>
                      <div className="mt-6 space-y-6">
                        <div className="flex items-center gap-x-3">
                          <input
                            id="cash"
                            value="cash"
                            checked={paymentMethod === "cash"}
                            name="payments"
                            onClick={handlePayment}
                            type="radio"
                            className="h-4 w-4 border-gray-300 text-gray-600 focus:ring-black"
                          />
                          <label
                            htmlFor="cash"
                            className="block text-sm font-medium leading-6 text-gray-900"
                          >
                            Cash
                          </label>
                        </div>
                        <div className="flex items-center gap-x-3">
                          <input
                            id="card"
                            name="payments"
                            value="card"
                            onClick={handlePayment}
                            checked={paymentMethod === "card"}
                            type="radio"
                            className="h-4 w-4 border-gray-300 text-gray-600 focus:ring-black"
                          />
                          <label
                            htmlFor="card"
                            className="block text-sm font-medium leading-6 text-gray-900"
                          >
                            Card Payment
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
